<template>
<div>
  <div class="top-nav clearfix large">
    <div class="logo pull-left">
      <img src="../../assets/images/wago-logo.png" alt="logo">
    </div>
    <div class="title pull-left">
      <span class="main-text">{{mainTitle}}</span>
      <span class="sub-text">{{subTitle}}</span>
    </div>

    <div class="user pull-right">
      <span class="name">{{user.userName}}</span>
      <span class="logout"><a href="javascript:;" @click="logout()">注销</a></span>
    </div>
  </div>

  <div class="top-nav clearfix small">
    <div class="wrapper">
      <div class="menu-icon" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <div class="logout" @click="logout()">
        <span>
          <i class="fa fa-power-off"></i>
        </span>
      </div>

      <div class="logo">
        <img src="../../assets/images/wago-logo.png" alt="logo">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import searchHistoryService from "../../services/searchHistoryService";
export default {
  name: "Navbar",
  props: {
    mainTitle: String,
    subTitle: String,
  },
  data() {
    return {
      index: ""
    };
  },
  methods: {
    logout() {
      searchHistoryService.removeAll();
      this.$store.commit(types.LOGOUT);
      this.$router.push({
        name: "Login"
      });
    },
    toggleMenu(){
      let sidebar = document.querySelector(".sidebar");
      sidebar.classList.toggle('open');
      event.stopPropagation();
    }
  },
  computed: {
    ...mapGetters(["user"])
  },
  created(){
  searchHistoryService.removeAll();
  },
  mounted(){
    let body = document.querySelector('body');
    let sidebar = document.querySelector(".sidebar");
    body.addEventListener("click",()=>{
      sidebar.classList.remove("open");
    })
  }
};
</script>


// WEBPACK FOOTER //
// src/components/navbar/Navbar.vue